// import '../UserHomepage/UserHome.scss';
import React, { useEffect, useState, useMemo } from 'react';
import { Layout, Button, Spin, Row, Col, Empty, Divider, Typography, Card, Table, Select } from 'antd';
import { BackendAPI } from '../../axios';
import axios from 'axios';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import { useNavigate } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import UserHeader from '../AuthComponents/UserHeader';
import UserNavbar from '../AuthComponents/UserNavbar';
import { Content, Footer } from 'antd/es/layout/layout';
import UserDashboard from '../AuthComponents/TransactionDashboard';
const { Title } = Typography;
const THEME_COLOR = "#1515b4";
const chartColors = [
  "#1515b4",
  "#2c2ce0",
  "#4d4dff",
  "#8080ff",
];

const { Sider } = Layout;
const { Option } = Select;

interface PageSettingsProps {
    isDarkMode: boolean;
}
const columns = [
    {
        title: 'Year Month',
        dataIndex: 'yearmonth',
        key: 'yearmonth',
        sorter: (a: TransactionData, b: TransactionData) => {
            // Parse the Year-Month string to a Date object or number for sorting
            const [yearA, monthA] = a.yearmonth.split('-').map(Number);
            const [yearB, monthB] = b.yearmonth.split('-').map(Number);
            return yearA === yearB ? monthA - monthB : yearA - yearB;
        },
    },
    {
        title: 'Services',
        dataIndex: 'txnType',
        key: 'txnType',
    },
    {
        title: 'Environment',
        dataIndex: 'environment',
        key: 'environment',
         render: (text: string) => {
            const color = text === 'Preproduction' ? 'orange' : text === 'Production' ? 'green' : 'black'; // Set color based on value
            return <span style={{ color: color, fontWeight: 'bold' }}>{text}</span>;
         },
    },
    {
        title: 'Count',
        dataIndex: 'txncount',
        key: 'txncount',
        sorter: (a: TransactionData, b: TransactionData) => a.txncount - b.txncount,
    },
];

interface TransactionData {
    yearmonth: string;
    txnType: string;
    environment: string;
    txncount: number;
}

function Dashboard2() {
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);
    const [isOnClickSlider, setOnclickSlider] = useState(false)
    const [data, setData] = useState<TransactionData[]>([]);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 830);
    

    const handleCollapse = (value: any) => {
        setCollapsed(value);
        setOnclickSlider(!isOnClickSlider);
    };
    useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 830);
  };

  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);
    let refreshToken: null;

    const getRefreshToken = async () => {
        try {
            const response = await BackendAPI.get("/user/refresh-token", { withCredentials: true });
            refreshToken = response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.request.status == 401) {
                    window.location.reload();
                }
            }
        } finally {
        setLoading(false);
      }
    };

    const getTransactionSummary = async () => {
        const url = `/txns/reg_id`;
        const header = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${refreshToken}`,
            },
        };

        try {
            const response = await BackendAPI.get(url, header);
            setData(response.data);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.request.status == 401) {
                    // handleLogout();
                }
            }
        } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
        const executeFunctions = async () => {
            await getRefreshToken();
            await getTransactionSummary();
        };
        executeFunctions();
    }, []);
    const formatNumber = (num: number) => {
      if (num >= 10000000) return (num / 10000000).toFixed(2) + " Cr";
      if (num >= 100000) return (num / 100000).toFixed(2) + " L";
      if (num >= 1000) return (num / 1000).toFixed(2) + " K";
      return num;
    };
      // =========================
      // 🔥 KPI CALCULATIONS
      // =========================
      const totalTransactions = useMemo(
        () => data.reduce((sum, d) => sum + d.txncount, 0),
        [data]
      );
    
      const totalProduction = useMemo(
        () =>
          data
            .filter((d) => d.environment === "Production")
            .reduce((sum, d) => sum + d.txncount, 0),
        [data]
      );
    
      const totalPreprod = useMemo(
        () =>
          data
            .filter((d) => d.environment === "Preproduction")
            .reduce((sum, d) => sum + d.txncount, 0),
        [data]
      );
    
      const uniqueTxnTypes = useMemo(
        () => Array.from(new Set(data.map((d) => d.txnType))).length,
        [data]
      );
    
      // =========================
      // 🔥 STACKED BAR DATA
      // Group by month + txnType
      // =========================
      const stackedData = useMemo(() => {
        if (!data.length) return [];
        const grouped: any = {};
    
        data.forEach((item) => {
          if (!grouped[item.yearmonth]) {
            grouped[item.yearmonth] = { yearmonth: item.yearmonth };
          }
          grouped[item.yearmonth][item.txnType] =
            (grouped[item.yearmonth][item.txnType] || 0) + item.txncount;
        });
    
        return Object.values(grouped).sort((a: any, b: any) =>
          // a.yearmonth.localeCompare(b.yearmonth)
        new Date(a.yearmonth + "-01").getTime() -
      new Date(b.yearmonth + "-01").getTime()
        );
      }, [data]);
    
      
    
      // =========================
      // 🔥 LINE TREND DATA
      // Group by month + environment
      // =========================
      const trendData = useMemo(() => {
        const grouped: any = {};
    
        data.forEach((item) => {
          if (!grouped[item.yearmonth]) {
            grouped[item.yearmonth] = { yearmonth: item.yearmonth };
          }
          grouped[item.yearmonth][item.environment] =
            (grouped[item.yearmonth][item.environment] || 0) + item.txncount;
        });
    
        return Object.values(grouped).sort((a: any, b: any) =>
          // a.yearmonth.localeCompare(b.yearmonth)
        new Date(a.yearmonth + "-01").getTime() -
      new Date(b.yearmonth + "-01").getTime()
        );
      }, [data]);
    
      // const txnTypes = Array.from(new Set(data.map((d) => d.txnType)));
      const txnTypes = useMemo(
      () => Array.from(new Set(data.map(d => d.txnType))),
      [data]
    );
    
      if (loading) {
        return (
          <div style={{ textAlign: "center", marginTop: 100 }}>
            <Spin size="large" />
          </div>
        );
      }

    return (
        <>
            {loading && (
                <Spin spinning={true} style={{ position: 'absolute', top: '50%', left: '50%', zIndex: 9999 }} indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
            )}
            {/* <div>
                <UserHeader setIsOnClickSlider={setOnclickSlider} />
            </div> */}
            <Layout style={{ minHeight: '89vh', }}>

                <Sider
                    // collapsed={isOnClickSlider}
                    collapsed={isMobile ? true : isOnClickSlider}
                    // trigger={null} // disable default trigger
                    // collapsible
                    collapsedWidth={50}
                    // onCollapse={handleCollapse}
                    style={{
                        // height: '90vh',
                        background: 'white',
                        position: 'relative',
                        overflow: 'auto',
                        top: '0px',
                        paddingTop: '20px',
                    }}
                >
                    {/* Custom collapse icon at top */}

                    <div style={{ top: '0', position: 'sticky', height: '100%', }}>
                        {/* Add menu or other content here */}
                        {/* <div
                            style={{
                                position: 'absolute',
                                top: 0, textAlignLast: 'right',
                                cursor: 'pointer', width: '100%', padding: '6px 16px',
                            }}
                            onClick={handleCollapse}
                        >
                            {collapsed ? <MenuUnfoldOutlined style={{ fontSize: '30px', }} /> : <MenuFoldOutlined style={{ fontSize: '30px', }} />}
                        </div> */}
                        <UserNavbar />
                        {/* <div style={{ textAlignLast: 'center', transition: 'all 0.9s', display: isOnClickSlider ? 'none' : 'block', position: 'absolute', justifySelf: 'center', bottom: '2%', }}>
                            <img src={cdac_logo} alt="Status" style={{ width: '40%', height: 'auto' }} />
                            <h5 style={{ textAlign: 'center', margin: '0' }}>Center for Development of Advanced Computing (C-DAC)</h5>
                        </div> */}
                    </div>
                </Sider>
                <Layout>
                    <Content style={{ padding: '0px 0px', overflowY: 'auto', maxHeight: 'calc(100vh - 80px)', paddingBottom: 32 }}>
                        <UserDashboard />
                        <div>
                            <Footer style={{ textAlign: 'center' }}>
                                ©2025 Copyright: C-DAC Mumbai. All Rights Reserved
                            </Footer>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}

export default Dashboard2
